module.exports = __webpack_public_path__ + "static/media/found1.e34c0896.png";